import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/layout.css";
import App from "./App";
// ชั้นตกแต่ง (ภาพประกอบ/พื้นหลัง/hover) — ต้องโหลดหลัง CSS ของหน้าอื่นเพื่อให้ override ได้
import "./styles/art.css"; // eslint-disable-line import/first
// ชั้นแนวหรู (ทอง-ม่วงเข้ม + ภาพตัวละคร) — โหลดท้ายสุดเพื่อ override
import "./styles/lux.css"; // eslint-disable-line import/first

createRoot(document.getElementById("root")).render(<App />);
